import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    businessName: Yup.string().nullable(),
    contactName: Yup.string().nullable(),
    contactPhone: Yup.string().nullable(),
    contactEmail: Yup.string().nullable().email("Please enter a valid email format"),
    additionalEmails: Yup.string().nullable(),
    accountingName: Yup.string().nullable(),
    accountingPhone: Yup.string().nullable(),
    accountingEmail: Yup.string().nullable().email("Please enter a valid email format"),
    description: Yup.string().nullable(),
    address1: Yup.string().required(),
    address2: Yup.string().nullable(),
    city: Yup.string().required(),
    state: Yup.string().required(),
    zipCode: Yup.string().required(),
    isPrimary: Yup.bool().nullable(),
    billingAddress: Yup.string().nullable(),
    locationCredentials: Yup.array()
});